<template>
    <v-container class="unauthorized fill-height" fluid>
        <v-row class="unauthorized__login" align="center" justify="center">
            <v-col cols="12" md="8">
                <v-card raised class="mx-auto" max-width="540px">
                    <v-img height="140px" src="../../assets/background/unauthenticated_cover.jpg">
                    </v-img>
                    <v-card-title class="headline">MyKing's Financial Services</v-card-title>
                    <v-card-subtitle class="font-weight-medium">King's University College</v-card-subtitle>
                    <v-card-text class="text--primary">
                        <v-alert border="left" :color="warningColor" prominent type="warning">
                            This resource is restricted to King's employees only. If you believe that you
                            should have access to this system, please contact your system administrator.
                        </v-alert>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'unauthorized',
    computed: {
        warningColor() {
            return '#ffa800'
        }
    }
}
</script>

<style scoped>
.headline {
    word-break: normal;
}

.unauthorized {
    background-image: url('../../assets/background/unauthenticated_bg.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
}
</style>